
















































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class BlogName extends Vue {
  min = 0;
  max = 100;
  meterValue = 50;
  low = 33;
  high = 66;
  optimum!: number;

  get snippet1 () {
    return `<p><span>عبد الرحمٰن</span>: Professor</p>
<p><bdi>عبد الرحمٰن</bdi>: Professor</p>`
  }

  get snippet2 () {
    return `<p>
Did you ever hear the tragedy of Darth Plagueis the Wise? I thought
not. It's not a story the Jedi would tell you. It's a Sith legend.
<mark>Darth Plagueis was a Dark Lord of the Sith</mark>, so powerful
and so wise he could use the Force to influence the midichlorians to
create life. He had such a knowledge of the dark side that he could even
keep the ones he cared about from dying. The dark side of the Force is a
pathway to many abilities some consider to be unnatural. He became so powerful,
the only thing he was afraid of was losing his power, which eventually,
of course, he did. Unfortunately, he taught his apprentice everything he
knew, then his apprentice killed him in his sleep. It's ironic 
he could save others from death, but not himself.
</p>`
  }

  get snippet3 () {
    return '<meter min="0" max="10" low="3" high="7" />'
  }

  get snippet4 () {
    return '<meter min="0" max="10" low="3" high="7" value="2"/>'
  }

  get snippet5 () {
    return '<meter min="0" max="10" low="3" high="7" value="9"/>'
  }

  get snippet6 () {
    return '<meter min="0" max="10" low="3" high="7" optimum="8" value="9" />'
  }

  get snippet7 () {
    return '<meter min="0" max="10" low="3" high="7" optimum="2" value="1" />'
  }

  get snippet8 () {
    return '<meter min="0" max="10" low="3" high="7" optimum="2" value="9" />'
  }

  get snippet9 () {
    return `<ruby>
  漢<rp>(</rp><rt>かん</rt><rp>)</rp>
</ruby>`
  }

  data () {
    return {
      optimum: this.optimum
    }
  }
}
